<template>
  <div class="row">
    <div class="col-12">
      <b-tabs v-model="tabIndex">
        <b-tab>
          <template #title>
            {{ $t('all') }}
            <small v-if="!countLoading">({{ count[0] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            Facebook page
            <small v-if="!countLoading">({{ count[1] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            Instagram
            <small v-if="!countLoading">({{ count[2] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            WhatsApp
            <small v-if="!countLoading">({{ count[3] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            Zalo OA
            <small v-if="!countLoading">({{ count[4] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            {{ $t('zaloUser') }}
            <small v-if="!countLoading">({{ count[5] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            Telegram
            <small v-if="!countLoading">({{ count[8] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            Tiktok
            <small v-if="!countLoading">({{ count[9] }})</small>
            <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
          </template>
        </b-tab>
      </b-tabs>
    </div>
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword"
                        :placeholder="$t('keyword')" v-on:keydown.enter="load"></b-form-input>
          <client-select v-if="!client" :model="filterFormModel" attribute="client" @change="load" :isFilter="true"
                         :place-holder="$t('selectClient')" class="mr-1 mb-1"></client-select>
          <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="status"
                       :options="statusOptions"></form-select>
          <form-select v-if="tabIndex === 5" :model="filterFormModel" attribute="topic" :options="topicOptions"
                       class="mr-1 mb-1"></form-select>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div v-if="tabIndex === 5" class="col-4 mb-3">
      <div class="bg-white rounded py-4 text-center">
        <p class="mb-1">{{ $t('totalZaloUser') }}</p>
        <h2 class="mb-3 mt-2 mb-lg-0">{{ count[5] | numFormat }}</h2>
        <div class="mt-2">
          <div class="text-left ml-4" v-for="count in dataCountByTopic" :key="count._id">
            <span v-if="count._id">{{ count._id }}: </span>
            <span v-else>{{ $t('unknown') }}: </span>
            <b>{{ count.total }}</b>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabIndex === 5" class="col-4 mb-3">
      <div class="bg-white rounded py-4 text-center">
        <p class="mb-1">{{ $t('activated') }}</p>
        <h2 class="mb-3 mt-2 mb-lg-0">{{ count[6] | numFormat }}</h2>
        <div class="mt-2">
          <div class="text-left ml-4" v-for="count in dataCountByTopic" :key="count._id">
            <span v-if="count._id">{{ count._id }}: </span>
            <span v-else>{{ $t('unknown') }}: </span>
            <b>{{ count.isActive }}</b>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabIndex === 5" class="col-4 mb-3">
      <div class="bg-white rounded py-4 text-center">
        <p class="mb-1">{{ $t('currentlyLoggedIn') }}</p>
        <h2 class="mb-3 mt-2 mb-lg-0">{{ count[7] | numFormat }}</h2>
        <div class="mt-2">
          <div class="text-left ml-4" v-for="count in dataCountByTopic" :key="count._id">
            <span v-if="count._id">{{ count._id }}: </span>
            <span v-else>{{ $t('unknown') }}: </span>
            <b>{{ count.isLogin }}</b>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-1"></div>
          <div class="col-lg-5">{{ $t('info') }}</div>
          <div class="col-lg-4">{{ $t('status') }}</div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-1">
            <figure class="c-board-table__avatar">
              <!--              <img v-if="item.avatar" v-bind:src="item.avatar" :alt="item.name" class="thumbnail"/>-->
              <img src="/img/default-avatar.png" :alt="item.name" class="thumbnail"/>
            </figure>
          </div>
          <div class="col-lg-5">
            <div v-if="item.client">
              <span>Domain: </span><b>{{ item.client.domain }}</b>
            </div>
            <div v-if="item.type === 'facebook'">
              <div>
                <span>{{ $t('facebookPageName') }}: </span> <b>{{ item.name ? item.name : $t('notUpdated') }}</b>
              </div>
              <div v-if="item.facebookPageId">
                <span>Page ID: </span><b>{{ item.facebookPageId }}</b>
              </div>
              <div v-if="item.desc">
                <span>{{ $t('desc') }}: </span><b>{{ item.desc }}</b>
              </div>
              <div>
                <span class="badge badge-primary">Facebook page</span>
              </div>
            </div>
            <div v-if="item.type === 'instagram'">
              <div>
                <span>{{ $t('accountName') }}: </span> <b>{{ item.name ? item.name : $t('notUpdated') }}</b>
              </div>
              <div v-if="item.instagramId">
                <span>Instagram ID: </span><b>{{ item.instagramId }}</b>
              </div>
              <div v-if="item.desc">
                <span>{{ $t('desc') }}: </span><b>{{ item.desc }}</b>
              </div>
              <div>
                <span class="badge badge-primary">Instagram</span>
              </div>
            </div>
            <div v-if="item.type === 'whatsapp'">
              <div>
                <span>{{ $t('accountName') }}: </span> <b>{{ item.name ? item.name : $t('notUpdated') }}</b>
              </div>
              <div v-if="item.whatsappNumber">
                <span>{{ $t('phone') }}: </span><b>{{ item.whatsappNumber }}</b>
              </div>
              <div v-if="item.desc">
                <span>{{ $t('desc') }}: </span><b>{{ item.desc }}</b>
              </div>
              <div>
                <span class="badge badge-primary">WhatsApp</span>
              </div>
            </div>
            <div v-if="item.type === 'zalo-user'">
              <div>
                <span>{{ $t('accountName') }}: </span> <b>{{ item.name ? item.name : $t('notUpdated') }}</b>
              </div>
              <div>
                <span>{{ $t('phone') }}: </span><b>{{ item.zaloId }}</b>
              </div>
              <div v-if="item.desc">
                <span>{{ $t('desc') }}: </span><b>{{ item.desc }}</b>
              </div>
              <div>
                <span class="badge badge-primary">{{ $t('zaloUser') }}</span>
              </div>
            </div>
            <div v-if="item.type === 'zalo'">
              <div>
                <span>{{ $t('zaloOAName') }}: </span> <b>{{ item.name ? item.name : $t('notUpdated') }}</b>
              </div>
              <div>
                <span>OA ID: </span><b>{{ item.oaId }}</b>
              </div>
              <div v-if="item.desc">
                <span>{{ $t('desc') }}: </span><b>{{ item.desc }}</b>
              </div>
              <div v-if="item.zaloQuota">
                <span>{{ $t('zaloQuota') }}: <b>{{ item.zaloQuota }}</b></span>
              </div>
              <div>
                <span class="badge badge-primary">Zalo OA</span>
              </div>
            </div>
            <div v-if="item.type === 'telegram'">
              <div>
                <span>{{ $t('accountName') }}: </span> <b>{{ item.name ? item.name : $t('notUpdated') }}</b>
              </div>
              <div v-if="item.telegramId">
                <span>Telegram ID: </span><b>{{ item.telegramId }}</b>
                <br>
                <span>{{ $t('username') }}: </span><b>{{ item.telegramUsername }}</b>
              </div>
              <div v-if="item.desc">
                <span>{{ $t('desc') }}: </span><b>{{ item.desc }}</b>
              </div>
              <div>
                <span class="badge badge-primary">Telegram</span>
              </div>
            </div>
            <div v-if="['tiktok', 'pancake-tiktok', 'pancake-tiktok_business_messaging'].includes(item.type)">
              <div>
                <span>{{ $t('accountName') }}: </span> <b>{{ item.name ? item.name : $t('notUpdated') }}</b>
                <span v-if="item.name !== item.tiktokName">({{ item.tiktokName }})</span>
              </div>
              <div v-if="item.tiktokId">
                <span>Open ID: </span>
                <b>{{ item.tiktokId }}</b>
              </div>
              <div v-if="item.tiktokUsername">
                <span>Username: </span>
                <a :href="item.tiktokLink || `https://www.tiktok.com/@${item.tiktokUsername}`"
                   target="_blank">@{{ item.tiktokUsername }}</a>
              </div>
              <div>
                <span v-if="item.tiktokIsBusiness" class="badge badge-primary mr-1">
                                  {{ $t('tiktokBusinessAccount') }}</span>
                <span v-if="item.tiktokIsVerified" class="badge badge-success mr-1">
                                  {{ $t('tiktokVerifiedAccount') }}</span>
              </div>
              <div v-if="item.desc">
                <span>{{ $t('desc') }}: </span><b>{{ item.desc }}</b>
              </div>
              <div v-if="item.pancake"><span>{{ $t('source') }}: </span>
                <b>
                  {{ $t('pancakeIntegration') }}
                </b>
              </div>
            </div>
          </div>
          <div
              v-if="['facebook', 'instagram', 'whatsapp', 'telegram', 'tiktok', 'pancake-tiktok', 'pancake-tiktok_business_messaging'].includes(item.type)"
              class="col-lg-4">
            <div v-if="item.createdBy">
              <span>{{ $t('createdBy') }}: </span> <b>{{ item.createdBy.name }}</b>
            </div>
            <div>
              <span>{{ $t('createTime') }}: </span> <b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div v-if="item.updateTime">
              <span>{{ $t('updateTime') }}: </span> <b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div v-if="item.type === 'tiktok' && item.tiktokRefreshTokenExpireTime">
              <span>{{ $t('expireTime') }}: </span>
              <b :class="{
                          'text-danger': item.tiktokRefreshTokenExpireTime < Date.now(),
                          'text-success': item.tiktokRefreshTokenExpireTime >= Date.now(),
                          'text-warning': item.tiktokRefreshTokenExpireTime >= Date.now() && item.tiktokRefreshTokenExpireTime < Date.now() + 7 * 24 * 60 * 60 * 1000,
                        }">{{ item.tiktokRefreshTokenExpireTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div>
              <span v-if="item.active" class="badge badge-success">{{ $t('activated') }}</span>
              <span v-else class="badge badge-danger">{{ $t('deactivated') }}</span>
            </div>
            <div
                v-if="!['telegram', 'tiktok', 'pancake-tiktok', 'pancake-tiktok_business_messaging'].includes(item.type)">
              <span v-if="item.facebookToken && item.type !== 'whatsapp'"
                    class="badge badge-success">{{ $t('accessGranted') }}</span>
              <span v-else-if="item.type !== 'whatsapp'" class="badge badge-danger">{{ $t('accessNotGranted') }}</span>
            </div>
            <div v-else>
              <template v-if="item.type === 'telegram'">
                <span v-if="item.telegramToken"
                      class="badge badge-success">{{ $t('accessGranted') }}</span>
                <span v-else class="badge badge-danger">{{ $t('accessNotGranted') }}</span>
              </template>
              <template v-if="item.type === 'tiktok'">
                <span v-if="item.tiktokAccessToken" class="badge badge-success mr-1">
                  {{ $t('accessGranted') }}
                </span>
                <span v-else class="badge badge-warning mr-1">{{ $t('accessNotGranted') }}</span>
              </template>
            </div>
          </div>
          <div v-if="item.type === 'zalo-user'" class="col-lg-4">
            <div v-if="item.createdBy">
              <span>{{ $t('createdBy') }}: </span> <b>{{ item.createdBy.name }}</b>
            </div>
            <div>
              <span>{{ $t('createTime') }}: </span> <b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div v-if="item.updateTime">
              <span>{{ $t('updateTime') }}: </span> <b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div v-if="item.pauseTime">
              <span>{{ $t('pauseTime') }}: </span> <b>{{ item.pauseTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div>
              <span v-if="item.status === 'active'" class="badge badge-success mr-1">{{ $t('accessGranted') }}</span>
              <span v-else-if="item.active" class="badge badge-warning mr-1">{{ $t('logout') }}</span>
              <span v-else class="badge badge-danger mr-1">{{ $t('deactivated') }}</span>
              <span v-if="item.status === 'active' && item.active" class="badge badge-success mr-1">{{ $t('activated') }}</span>
            </div>
          </div>
          <div v-if="item.type === 'zalo'" class="col-lg-4">
            <div v-if="item.createdBy">
              <span>{{ $t('createdBy') }}: </span> <b>{{ item.createdBy.name }}</b>
            </div>
            <div>
              <span>{{ $t('createTime') }}: </span> <b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div v-if="item.updateTime">
              <span>{{ $t('updateTime') }}: </span> <b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div v-if="item.zaloTokenIssueTime">
              <span>{{ $t('authorizationTime') }}: </span>
              <b>{{ item.zaloTokenIssueTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
            </div>
            <div>
              <span v-if="item.active" class="badge badge-success">{{ $t('activated') }}</span>
              <span v-else class="badge badge-danger">{{ $t('deactivated') }}</span>
            </div>
            <div>
              <span v-if="item.zaloTokenIssueTime" class="badge badge-success">{{ $t('accessGranted') }}</span>
              <span v-else class="badge badge-danger">{{ $t('accessNotGranted') }}</span>
            </div>
            <div>
                <span v-if="item.zaloTokenIssueTime && item.zaloTokenIssueTime + 90 * 24 * 60 * 60 * 1000 < Date.now()"
                      class="badge badge-danger">{{ $t('expired') }}</span>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="c-buttons__col">
              <button @click="update(item._id, 'facebook')" type="button"
                      v-if="item.type === 'facebook'"
                      class="btn btn-sm btn-info mr-1">
                <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
              </button>
              <button @click="update(item._id, 'zalo')" type="button"
                      v-if="item.type === 'zalo'"
                      class="btn btn-sm btn-info mr-1">
                <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
              </button>
              <button @click="update(item._id, 'zalo-user')" type="button"
                      v-if="item.type === 'zalo-user'"
                      class="btn btn-sm btn-info mr-1">
                <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
              </button>
              <button @click="update(item._id, 'whatsapp')" type="button"
                      v-if="item.type === 'whatsapp'"
                      class="btn btn-sm btn-info mr-1">
                <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
              </button>
              <button @click="update(item._id, 'instagram')" type="button"
                      v-if="item.type === 'instagram'"
                      class="btn btn-sm btn-info mr-1">
                <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
              </button>
              <button @click="update(item._id, 'telegram')" type="button"
                      v-if="item.type === 'telegram'"
                      class="btn btn-sm btn-info mr-1">
                <font-awesome-icon icon="edit"/>
                {{ $t('edit') }}
              </button>
              <button @click="update(item._id, 'tiktok')" type="button"
                      v-if="['tiktok', 'pancake-tiktok', 'pancake-tiktok_business_messaging'].includes(item.type)"
                      class="btn btn-sm btn-info mr-1">
                <font-awesome-icon icon="edit"/>
                {{ $t('edit') }}
              </button>
              <button @click="deleteAccount(item._id, '/facebook-page/')" type="button"
                      class="btn btn-sm btn-danger mr-1"
                      v-if="['owner','admin', 'tech'].includes($store.state.user.role) && item.type === 'facebook'">
                <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
              </button>
              <button @click="deleteAccount(item._id, '/zalo-oa/')" type="button" class="btn btn-sm btn-danger mr-1"
                      v-if="['owner','admin', 'tech'].includes($store.state.user.role) && item.type === 'zalo'">
                <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
              </button>
              <button @click="deleteAccount(item._id, '/zalo-user/')" type="button" class="btn btn-sm btn-danger mr-1"
                      v-if="['owner','admin', 'tech'].includes($store.state.user.role) && item.type === 'zalo-user'">
                <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
              </button>
              <button @click="deleteAccount(item._id, '/instagram/')" type="button" class="btn btn-sm btn-danger mr-1"
                      v-if="['owner','admin', 'tech'].includes($store.state.user.role) && item.type === 'instagram'">
                <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
              </button>
              <button @click="deleteAccount(item._id, '/whatsapp/')" type="button" class="btn btn-sm btn-danger mr-1"
                      v-if="['owner','admin', 'tech'].includes($store.state.user.role) && item.type === 'whatsapp'">
                <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
              </button>
              <button @click="deleteAccount(item._id, '/telegram/')" type="button" class="btn btn-sm btn-danger mr-1"
                      v-if="['owner','admin', 'tech'].includes($store.state.user.role) && item.type === 'telegram'">
                <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
              </button>
              <button @click="deleteAccount(item._id, '/tiktok/')" type="button" class="btn btn-sm btn-danger mr-1"
                      v-if="['owner','admin', 'tech'].includes($store.state.user.role) && ['tiktok', 'pancake-tiktok', 'pancake-tiktok_business_messaging'].includes(item.type)">
                <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
              </button>
              <button @click="logoutZaloUser(item._id)" type="button"
                      v-if="item.type === 'zalo-user'"
                      class="btn btn-sm btn-warning mr-1">
                <font-awesome-icon icon="sign-out-alt"/>&nbsp;{{ $t('logOut') }}
              </button>
              <z-n-s-template-modal :zaloOA="item" v-if="item.type === 'zalo'"></z-n-s-template-modal>
              <facebook-template-modal :facebookPage="item" v-if="item.type === 'facebook'"></facebook-template-modal>
              <whats-app-template-modal :whatsapp="item" v-if="item.type === 'whatsapp'"></whats-app-template-modal>
              <button @click="getAllTemplate(item._id)" type="button"
                      v-if="item.type === 'zalo'"
                      class="btn btn-sm btn-warning mr-1">
                <font-awesome-icon icon="comment"/>&nbsp;{{ $t('getZNSTemplate') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span>{{ $t('noSocialNetworkAccountSetup') }}</span>
    </div>
    <b-modal v-model="showFormFacebook" :title="formTitle" no-close-on-backdrop>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                  :label="$t('facebookPageName')"></form-input>
      <form-input :model="formModel" :errors="formErrors" attribute="facebookPageId" label="Facebook Page ID"
                  :disabled="true"></form-input>
      <form-textarea :disabled="true" :model="formModel" :errors="formErrors" attribute="desc"
                     :label="$t('desc')"></form-textarea>
      <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="ml-1" @click="showFormFacebook = false">
          {{ $t('close') }}
        </b-button>
        <b-button variant="primary" class="ml-1" @click="save('facebook')"
                  :disabled="!['owner', 'admin', 'tech'].includes($store.state.user.role)">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showFormWhatsapp" :title="formTitle" no-close-on-backdrop>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                  :label="$t('accountName')"></form-input>
      <form-input :model="formModel" :errors="formErrors" attribute="whatsappId" label="WABA_ID"
                  :disabled="true"></form-input>
      <form-input :model="formModel" :errors="formErrors" attribute="whatsappNumberId" label="NUMBER_ID"
                  :disabled="true"></form-input>
      <form-textarea :disabled="true" :model="formModel" :errors="formErrors" attribute="desc"
                     :label="$t('desc')"></form-textarea>
      <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="ml-1" @click="showFormWhatsapp = false">
          {{ $t('close') }}
        </b-button>
        <b-button variant="primary" class="ml-1" @click="save('whatsapp')"
                  :disabled="!['owner', 'admin', 'tech'].includes($store.state.user.role)">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showFormInstagram" :title="formTitle" no-close-on-backdrop>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                  :label="$t('accountName')"></form-input>
      <form-input :model="formModel" :errors="formErrors" attribute="instagramId" label="Instagram ID"
                  :disabled="true"></form-input>
      <form-textarea :disabled="true" :model="formModel" :errors="formErrors" attribute="desc"
                     :label="$t('desc')"></form-textarea>
      <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="ml-1" @click="showFormInstagram = false">
          {{ $t('close') }}
        </b-button>
        <b-button variant="primary" class="ml-1" @click="save('instagram')"
                  :disabled="!['owner', 'admin', 'tech'].includes($store.state.user.role)">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showFormZaloUser" :title="formTitle" no-close-on-backdrop>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                  :label="$t('accountName')"></form-input>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="zaloId"
                  :label="$t('phone')"></form-input>
      <form-select label="Topic" :model="formModel" attribute="topic" :options="topicOptions"></form-select>
      <form-input :model="formModel" :errors="formErrors" attribute="userAgent"
                  :label="$t('userAgent')"></form-input>
      <form-textarea :disabled="true" :model="formModel" :errors="formErrors" attribute="desc"
                     :label="$t('desc')"></form-textarea>
      <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="ml-1" @click="showFormZaloUser = false">
          {{ $t('close') }}
        </b-button>
        <b-button variant="primary" class="ml-1" @click="saveFormZaloUser"
                  :disabled="!['owner', 'admin', 'tech'].includes($store.state.user.role)">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showFormZalo" :title="formTitle" no-close-on-backdrop>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                  :label="$t('zaloOAName')"></form-input>
      <form-input :model="formModel" :errors="formErrors" attribute="oaId" label="OA ID"
                  :disabled="true"></form-input>
      <form-textarea :disabled="true" :model="formModel" :errors="formErrors" attribute="desc"
                     :label="$t('desc')"></form-textarea>
      <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="ml-1" @click="showFormZalo = false">
          {{ $t('close') }}
        </b-button>
        <b-button variant="primary" class="ml-1" @click="save('zalo')"
                  :disabled="!['owner', 'admin', 'tech'].includes($store.state.user.role)">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showFormTelegram" :title="formTitle" no-close-on-backdrop>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                  :label="$t('accountName')"></form-input>
      <form-input :model="formModel" :errors="formErrors" attribute="telegramId" label="Telegram ID"
                  :disabled="true"></form-input>
      <form-textarea :disabled="true" :model="formModel" :errors="formErrors" attribute="desc"
                     :label="$t('desc')"></form-textarea>
      <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="ml-1" @click="showFormTelegram = false">
          {{ $t('close') }}
        </b-button>
        <b-button variant="primary" class="ml-1" @click="save('telegram')"
                  :disabled="!['owner', 'admin', 'tech'].includes($store.state.user.role)">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showFormTiktok" :title="formTitle" no-close-on-backdrop>
      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
      <form-input :disabled="true" :model="formModel" :errors="formErrors" attribute="name"
                  :label="$t('accountName')"></form-input>
      <form-textarea :disabled="true" :model="formModel" :errors="formErrors" attribute="desc"
                     :label="$t('desc')"></form-textarea>
      <form-checkbox :disabled="true" :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="ml-1" @click="showFormTelegram = false">
          {{ $t('close') }}
        </b-button>
        <b-button variant="primary" class="ml-1" @click="save('tiktok')"
                  :disabled="!['owner', 'admin', 'tech'].includes($store.state.user.role)">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import List from '@/mixins/List'
import CRUD from '@/mixins/CRUD'
import ZNSTemplateModal from '@/views/message/ZNSTemplateModal.vue'
import ClientSelect from '@/components/ClientSelect.vue'
import FacebookTemplateModal from '@/views/client/client-info/FacebookTemplateModal.vue'
import WhatsAppTemplateModal from '@/views/client/client-info/WhatsAppTemplateModal.vue'

export default {
  components: {WhatsAppTemplateModal, FacebookTemplateModal, ClientSelect, ZNSTemplateModal},
  mixins: [List, CRUD],
  props: ['client'],
  data() {
    return {
      service: '/social-network-account',
      autoLoad: true,
      defaultFilterFormModel: {
        type: null,
        client: this.client ? this.client._id : null,
        topic: null,
        status: null,
      },
      showFormFacebook: false,
      showFormZalo: false,
      showFormWhatsapp: false,
      showFormInstagram: false,
      showFormZaloUser: false,
      showFormTelegram: false,
      showFormTiktok: false,
      actionOpts: [
        {value: null, text: this.$t('selectAccountType')},
        {value: 'facebook', text: 'Facebook page'},
        {value: 'instagram', text: 'Instagram'},
        {value: 'whatsapp', text: 'WhatsApp'},
        {value: 'zalo', text: 'Zalo OA'},
        {value: 'zalo-user', text: this.$t('zaloUser')},
        {value: 'telegram', text: 'Telegram'},
      ],
      tabIndex: 0,
      accountType: [null, 'facebook', 'instagram', 'whatsapp', 'zalo', 'zalo-user', 'telegram', 'tiktok'],
      count: {},
      countLoading: true,
      afterLoad: () => {
        this.getCount()
        if (this.tabIndex === 5) {
          this.getCountByTopic()
        }
      },
      topicOptions: [],
      dataCountByTopic: [],
      statusOptions: [
        {value: null, text: this.$t('selectStatus')},
        {value: 'activated', text: this.$t('activated')},
        {value: 'deactivated', text: this.$t('deactivated')},
        {value: 'accessGranted', text: this.$t('accessGranted')},
        {value: 'accessNotGranted', text: this.$t('accessNotGranted')}
      ],
    }
  },
  watch: {
    tabIndex: function () {
      this.defaultFilterFormModel.type = this.accountType[this.tabIndex]
      this.filterFormModel.type = this.accountType[this.tabIndex]
      this.filterFormModel.topic = null
      this.load()
    }
  },
  methods: {
    deleteAccount: function (id, type) {
      this.$swal({
        title: this.$t('deleteConfirm'),
        text: this.$t('deleteAlert'),
        icon: 'warning',
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.delete(this.service + type + id, {
            params: this.filterFormModel
          }).then(response => {
            if (response.data) {
              if (this.load) {
                this.load()
              }
              this.$swal({
                icon: 'success',
                text: this.$t('deleted'),
                toast: true,
                position: 'top-end',
                timer: 5000
              })
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('deleteFailed'),
                icon: 'error',
                toast: true,
                position: 'top-end',
                timer: 5000
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              })
            }
          })
        }
      })
    },
    update: function (id, type) {
      let uri = this.service
      if (id) {
        uri += '/' + id
      }
      this.$service.get(uri, {
        params: this.filterFormModel
      }).then(response => {
        this.formModel = {}
        this.formTitle = this.$t('update')
        this.formErrors = []
        if (type === 'facebook') {
          this.showFormFacebook = true
        } else if (type === 'whatsapp') {
          this.showFormWhatsapp = true
        } else if (type === 'instagram') {
          this.showFormInstagram = true
        } else if (type === 'zalo-user') {
          this.showFormZaloUser = true
        } else if (type === 'telegram') {
          this.showFormTelegram = true
        } else if (type === 'tiktok') {
          this.showFormTiktok = true
        } else {
          this.showFormZalo = true
        }
        this.formModel = response.data
        this.formModel.id = id
      })
    },
    getAllTemplate(id) {
      let loader = this.$loading.show()
      this.$service.get(`/zns-template/all/${id}`)
          .then(() => {
            this.$swal({
              icon: 'success',
              text: this.$t('syncSuccess'),
              timer: 5000
            })
          })
          .catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              })
            }
          })
          .finally(() => {
            loader.hide()
          })
    },
    logoutZaloUser(id) {
      this.$swal({
        title: this.$t('logoutConfirm'),
        icon: 'warning',
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.post(this.service + '/logout/' + id)
              .then(response => {
                if (response.data) {
                  if (this.load) {
                    this.load()
                  }
                  this.$swal({
                    icon: 'success',
                    text: this.$t('loggedOut'),
                    toast: true,
                    position: 'top-end',
                    timer: 5000
                  })
                } else {
                  this.$swal({
                    title: this.$t('error'),
                    text: this.$t('logoutFailed'),
                    icon: 'error',
                    toast: true,
                    position: 'top-end',
                    timer: 5000
                  })
                }
              })
              .catch(error => {
                if (error.response.data.message) {
                  this.$swal({
                    text: error.response.data.message,
                    icon: 'error'
                  })
                }
              })
        }
      })
    },
    getCount() {
      this.countLoading = true
      this.$service.get(this.service + '/count', {params: this.filterFormModel})
          .then(response => {
            this.count = response.data
          })
          .catch(() => {
            this.count = {}
          })
          .finally(() => {
            this.countLoading = false
          })
    },
    getTopicOptions() {
      let defaultTopicOptions = [{value: null, text: this.$t('selectTopic')}]
      this.topicOptions = defaultTopicOptions
      this.$bgService.get(this.service + '/zalo-user/topic').then(res => {
        this.topicOptions = [...defaultTopicOptions, ...res.data]
      })
    },
    getCountByTopic() {
      this.dataCountByTopic = []
      this.$bgService.get(this.service + '/count-by-topic', {params: this.filterFormModel})
          .then(res => {
            this.dataCountByTopic = res.data
          })
    },
    saveFormZaloUser: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      let loader = this.$loading.show();
      let method = 'put';
      let url = this.service + '/zalo-user/' + this.formModel.id;
      this.$service({url: url, method: method, data: this.formModel}).then(response => {
        this.showFormZaloUser = false;
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showFormZaloUser = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    save: function (formType, evt, fn, customUrl) {
      if (evt) {
        evt.preventDefault();
      }
      let loader = this.$loading.show();
      let method = 'post';
      let url = this.service;
      if (this.formModel.id) {
        method = 'put';
        url += '/' + this.formModel.id;
      }
      if (customUrl) {
        url = customUrl;
      }
      this.$service({url: url, method: method, data: this.formModel}).then(response => {
        switch (formType) {
          case 'facebook':
            this.showFormFacebook = false
            break
          case 'whatsapp':
            this.showFormWhatsapp = false
            break
          case 'instagram':
            this.showFormInstagram = false
            break
          case 'zalo':
            this.showFormZalo = false
            break
          case 'telegram':
            this.showFormTelegram = false
            break
          case 'tiktok':
            this.showFormTiktok = false
            break
        }
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (fn) {
          fn();
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          switch (formType) {
            case 'facebook':
              this.showFormFacebook = false
              break
            case 'whatsapp':
              this.showFormWhatsapp = false
              break
            case 'instagram':
              this.showFormInstagram = false
              break
            case 'zalo':
              this.showFormZalo = false
              break
            case 'telegram':
              this.showFormTelegram = false
              break
            case 'tiktok':
              this.showFormTiktok = false
              break
          }
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
  },
  mounted() {
    this.getTopicOptions()
  },
  i18n: {
    messages: {
      en: {
        facebookPageName: 'Facebook page name',
        zaloOAName: 'Zalo OA Name',
        accessGranted: 'Access granted',
        accessNotGranted: 'Access not granted',
        authorizationTime: 'Authorization time',
        noSocialNetworkAccountSetup: 'No social network account setup',
        close: 'Close',
        selectAccountType: 'Select account type',
        getZNSTemplate: 'Get ZNS Templates',
        syncSuccess: 'ZNS Template synchronization successful',
        accountName: 'Account name',
        zaloUser: 'Personal Zalo',
        logOut: 'Logout',
        logoutConfirm: 'Are you sure you want to logout?',
        loggedOut: 'Logout successfully',
        logoutFailed: 'Logout failed',
        totalZaloUser: 'Total number of personal Zalo',
        currentlyLoggedIn: 'Currently logged in',
        selectTopic: 'Select topic',
        createdBy: 'Created by',
        pauseTime: 'Pause time',
        paused: 'Paused',
        logout: 'Logout',
        userAgent: 'User agent',
        selectStatus: 'Select status',
        tiktokBusinessAccount: 'Business',
        tiktokVerifiedAccount: 'Verified',
        source: 'Source',
        pancakeIntegration: 'Pancake integration',
      },
      vi: {
        facebookPageName: 'Tên Facebook Page',
        zaloOAName: 'Tên Zalo OA',
        accessGranted: 'Đã cấp quyền truy cập',
        accessNotGranted: 'Chưa cấp quyền truy cập',
        authorizationTime: 'Cấp quyền lúc',
        noSocialNetworkAccountSetup: 'Bạn chưa cài đặt tài khoản mạng xã hội',
        close: 'Đóng',
        selectAccountType: 'Chọn loại tài khoản',
        getZNSTemplate: 'Lấy ZNS Template',
        syncSuccess: 'Đồng bộ ZNS Template thành công',
        accountName: 'Tên tài khoản',
        zaloUser: 'Zalo cá nhân',
        logOut: 'Đăng xuất',
        logoutConfirm: 'Bạn chắc chắn muốn đăng xuất chứ?',
        loggedOut: 'Đăng xuất thành công',
        logoutFailed: 'Đăng xuất thất bại',
        totalZaloUser: 'Tổng số Zalo cá nhân',
        currentlyLoggedIn: 'Đang đăng nhập',
        selectTopic: 'Chọn topic',
        createdBy: 'Tạo bởi',
        pauseTime: 'Tạm dừng lúc',
        paused: 'Tạm dừng',
        logout: 'Đăng xuất',
        userAgent: 'Đại diện người dùng',
        selectStatus: 'Chọn trạng thái',
        tiktokBusinessAccount: 'TikTok Business',
        tiktokVerifiedAccount: 'TikTok Đã xác minh',
        source: 'Nguồn',
        pancakeIntegration: 'Tích hợp Pancake',
      }
    }
  }
}
</script>

<style>
.c-board-table__avatar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #fff;
  border-radius: 50%;
}

.c-board-table__avatar img {
  width: auto;
  height: auto;
  min-height: 100%;
  min-width: 100%;
}
</style>